<template>
  <main class="forbidden-page">
    <section class="forbidden-panel ui-empty" aria-labelledby="forbidden-title">
      <div class="section-kicker">Access restricted</div>
      <h1 id="forbidden-title">Forbidden</h1>
      <p>This account does not have permission to open that page.</p>
      <button class="btn-primary" type="button" @click="goHome">Return home</button>
    </section>
  </main>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { roleHomePath } from '../router'

const router = useRouter()
const auth = useAuthStore()

function goHome() {
  router.replace(roleHomePath(auth.role))
}
</script>

<style scoped>
.forbidden-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: var(--canvas);
  padding: var(--space-8) var(--space-6);
}

.forbidden-panel {
  width: min(480px, 100%);
  min-height: 0;
  justify-items: center;
  border-style: solid;
  background: var(--surface);
}

.forbidden-panel h1 {
  margin: var(--space-2) 0;
  color: var(--ink);
  font-family: var(--font-academic);
  font-size: 2rem;
  line-height: 1.15;
}

.forbidden-panel p {
  margin: 0 0 var(--space-6);
  color: var(--ink-muted);
  font-size: 0.875rem;
  line-height: 1.5;
}

@media (max-width: 767px) {
  .forbidden-page {
    padding: var(--space-4);
  }
}
</style>
